import httpClient from '@utils/httpClient.js';

export function updateTextApiCall(options) {
  const { id, content } = options;

  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/text`, {
    id,
    content,
  });
}
